module.exports = __webpack_public_path__ + "na.svg?4feab8bcffab6b7c31a7ede9accb737a";